module.exports = __webpack_public_path__ + "static/media/learn4.bdcd5ce9.jpg";